module.exports = __webpack_public_path__ + "img/nba-newhires.65f3287c.jpg";